// @flow
import * as React from 'react'
import { FormContext } from './Form'

type Validator = any => ?string
type Validators = Validator[] | Validator

type Props = {
  name: string,
  value: any,
  error?: string,
  required?: boolean,
}

export default function WithFormValidationFactory(Underlying: any, validators: Validators = []) {
  // eslint-disable-next-line no-param-reassign
  validators = Array.isArray(validators) ? validators : [validators]

  class WithFormValidation extends React.Component<Props> {
    static contextType = FormContext

    componentDidMount = () => {
      this.runValidation(this.props.name, this.props.value, !!this.props.required)
    }

    componentWillReceiveProps = (nextProps: Props) => {
      if (this.props.name !== nextProps.name) {
        this.clearExistingValidation(this.props.name)
      }

      if (nextProps.error !== undefined && nextProps.error !== this.props.error) {
        this.context.form && this.context.form.onInvalidValue(nextProps.name, nextProps.error)
      } else if (nextProps.error === undefined && this.props.value !== nextProps.value) {
        this.runValidation(nextProps.name, nextProps.value, !!nextProps.required)
      }
    }

    componentWillUnmount = () => {
      this.clearExistingValidation(this.props.name)
    }

    render = () => {
      if (!this.context.form) return <Underlying {...this.props} />

      const showFormError = this.context.form.showErrors
      const formErrorMaybe = showFormError && this.context.form.errors[this.props.name]

      return <Underlying {...this.props} error={formErrorMaybe} />
    }

    runValidation = (name: string, value: any, required: boolean) => {
      if (!this.context.form) return

      const validationError = validate(value, validators, required)

      return validationError
        ? this.context.form.onInvalidValue(name, validationError)
        : this.context.form.onValidValue(name)
    }

    clearExistingValidation = (name: string) => {
      if (!this.context.form) return

      this.context.form.onValidValue(name)
    }
  }

  return WithFormValidation
}

function validate(value, validators, required) {
  let error

  const toRun = value == null || value === '' ? [required ? isSet : noop] : validators
  toRun.some(validator => !!(error = validator(value)))

  return error
}

function isSet(val: any) {
  const errorText = 'is required'

  return !val ? errorText : undefined
}

function noop(_) {}
